/**
 * adds  Alpha value to RGB color string
 * @param rgb  - `"rgb(0 to 255, 0 to 255, 0 to 255)"`
 * @param alpha - `0 to 1`
 * @returns `rgba(255, 255, 255, 1)`
 */
export const addAlphaToRGB = (rgb: string, alpha: number) => {
    if (!rgb) return "";
    if (alpha < 0 || alpha > 1) return rgb;
    let newRgb = `${
        rgb.slice(0, -1) // remove `)` bracket
    }, ${
        alpha.toString() // add alpha
    })`;
    if (newRgb.startsWith("rgb(")) newRgb = newRgb.replace("rgb", "rgba");

    return newRgb;
};

/**
 * adds  Alpha value to hex color string
 * @param hex  - `"#ffffff"` or `"#fff"`
 * @param alpha - `0 to 1`
 * @returns `"#ffffff00"` or `"#fff0"`
 */

export const addAlphaToHex = (hex: string, alpha: number) => {
    if (!hex) return "";
    if (alpha < 0 || alpha > 1) return hex;

    let newAlpha = "";
    if (hex.length === 4) {
        // `"#fff"`

        // alpha can have hex value from (`00` or `0`) to (`FF` or `255`)
        newAlpha = Math.floor(alpha * 15).toString(16);
    } else if (hex.length === 7) {
        // `"#ffffff"`

        // alpha can have hex value from (`00` or `0`) to (`FF` or `255`)
        newAlpha = Math.floor(alpha * 255).toString(16);
    }

    const newHex = `${hex}${newAlpha}`;

    return newHex;
};
